import moment from 'moment'

// Mirrors the API rule in deliveryOrder/service.ts valudateRouteDate():
// after this hour (local time, America/Toronto for every real customer) the
// earliest bookable route date is tomorrow, and weekends are never bookable.
// Keep in sync with the API — the server is the source of truth.
export const SAME_DAY_CUTOFF_HOUR = 20 // API: `hours > 20` → 9 PM onward is tomorrow

const FORMAT = 'YYYY-MM-DD'

function parse(value) {
  if (!value) return null
  const strict = moment(value, FORMAT, true)
  if (strict.isValid()) return strict
  const loose = moment(value)
  return loose.isValid() ? loose : null
}

export function sameDayCutoffPassed(now = moment()) {
  return now.hour() > SAME_DAY_CUTOFF_HOUR
}

/** Earliest day a customer may book: today, or tomorrow past the cutoff, rolled off weekends. */
export function earliestRouteDate(now = moment()) {
  const d = now.clone().startOf('day')
  if (sameDayCutoffPassed(now)) d.add(1, 'day')
  while (d.isoWeekday() > 5) d.add(1, 'day')
  return d
}

/**
 * Coerce any picked value to a bookable day: invalid → earliest, weekend →
 * next Monday, before the earliest → earliest. Returns a moment.
 */
export function normalizeRouteDate(value, now = moment()) {
  const earliest = earliestRouteDate(now)
  let d = parse(value)
  if (!d) return earliest
  d = d.clone().startOf('day')
  while (d.isoWeekday() > 5) d.add(1, 'day')
  return d.isBefore(earliest) ? earliest : d
}

/** "Today · Thu, Sep 17" / "Tomorrow · Fri, Sep 18" / "Monday, Sep 21". */
export function routeDayLabel(value, now = moment()) {
  const d = parse(value)
  if (!d) return ''
  const diff = d
    .clone()
    .startOf('day')
    .diff(now.clone().startOf('day'), 'days')
  if (diff === 0) return `Today · ${d.format('ddd, MMM D')}`
  if (diff === 1) return `Tomorrow · ${d.format('ddd, MMM D')}`
  return d.format('dddd, MMM D')
}

export function routeDayHint(value, now = moment()) {
  const d = parse(value)
  if (!d) return ''
  const isToday = d
    .clone()
    .startOf('day')
    .isSame(now.clone().startOf('day'))
  if (isToday) return 'Same-day booking closes at 9 PM'
  if (
    sameDayCutoffPassed(now) &&
    d
      .clone()
      .startOf('day')
      .diff(now.clone().startOf('day'), 'days') === 1
  ) {
    return 'Same-day booking closed at 9 PM — earliest is tomorrow'
  }
  return ''
}
